import { render, staticRenderFns } from "./FeDialog.vue?vue&type=template&id=788e52bd&scoped=true&"
import script from "./FeDialog.vue?vue&type=script&lang=js&"
export * from "./FeDialog.vue?vue&type=script&lang=js&"
import style0 from "./FeDialog.vue?vue&type=style&index=0&id=788e52bd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e52bd",
  null
  
)

export default component.exports